import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { DashboardDataResponse } from "@/types/dashboard";

export const dashboardKeys = {
  details: (isDashboardBusinessFilter: boolean, businessName: string | null) =>
    ["dashboard", "details", isDashboardBusinessFilter, businessName] as const,
  businesses: () => ["dashboard", "businesses"] as const
};

export function useDashboardData(
  isDashboardBusinessFilter: boolean,
  businessName: string | null
) {
  return useQuery({
    queryKey: dashboardKeys.details(isDashboardBusinessFilter, businessName),
    queryFn: () => {
      const path =
        businessName != null
          ? `Dashboard/dashboard/${isDashboardBusinessFilter}/${encodeURIComponent(businessName)}`
          : `Dashboard/dashboard/${isDashboardBusinessFilter}`;
      return apiGet<DashboardDataResponse>(path);
    },
    placeholderData: (previousData) => previousData,
    staleTime: 60_000,
    refetchOnMount: "always"
  });
}


export function useBusinesses() {
  return useQuery({
    queryKey: dashboardKeys.businesses(),
    queryFn: () =>
      apiGet<Record<string, string[]>>("Business/GetBusinessAndBusinessLineTypes"),
    staleTime: 5 * 60_000,
    refetchOnMount: "always"
  });
}

// export async function useBusinesses(): Promise<Record<string, string[]> | undefined> {
//   return apiGet<Record<string, string[]>>(`Business/GetBusinessAndBusinessLineTypes`);
// }


